(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cm-meta-account-identity"] && !Shopify.designMode) return;
  try {
    (() => {
  const node = document.getElementById('cm-meta-account-identity');
  if (!node || window.cmMetaAccountIdentityLoaded) return;
  window.cmMetaAccountIdentityLoaded = true;
  const customer = node.dataset.customer;
  const cookieName = '_cm_meta_account_proof';
  let revision = 0;
  let pending;
  let refresh;
  let notificationTimer;
  let notified = false;
  const cookie = name => {
    const row = document.cookie.split('; ').find(value => value.startsWith(name+'='));
    return row ? row.slice(name.length+1) : '';
  };
  const clear = () => { notified = false; document.cookie = cookieName+'=; Path=/; Max-Age=0; SameSite=Lax; Secure'; };
  const permitted = () => {
    const p = window.Shopify?.customerPrivacy;
    return p?.marketingAllowed() === true && p?.analyticsProcessingAllowed() === true && p?.saleOfDataAllowed() === true;
  };
  const currentProof = () => {
    try {
      if (!permitted()) return false;
      const p = JSON.parse(decodeURIComponent(cookie(cookieName)));
      const now = Math.floor(Date.now()/1000);
      return p.customer === customer && cookie('_cm_meta_account') === customer &&
        /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(p.visitor || '') &&
        p.visitor === cookie('_cm_meta_id') && Number.isSafeInteger(p.expires) &&
        p.expires > now && p.expires <= now+120 && typeof p.proof === 'string' && p.proof.length > 0 && p.proof.length <= 2048;
    } catch { return false; }
  };
  const notifyPixel = async (ticket, attempt = 0) => {
    if (notified || ticket !== revision || !currentProof() || document.visibilityState === 'hidden') return;
    try {
      if (typeof window.Shopify?.analytics?.publish === 'function') {
        const sent = await window.Shopify.analytics.publish('cm_meta:account_identity_ready',{});
        if (ticket !== revision || !currentProof()) return;
        if (sent !== false) { notified = true; return; }
      }
    } catch {}
    if (ticket === revision && attempt < 5) notificationTimer = setTimeout(() => { void notifyPixel(ticket,attempt+1); },250);
  };
  const stop = (clearProof = true) => {
    revision++;
    clearTimeout(refresh);
    clearTimeout(notificationTimer);
    if (pending) pending.abort();
    pending = undefined;
    if (clearProof) clear();
  };
  const start = async () => {
    stop(false);
    // Keep a still-valid, account-bound proof available to early page/product events.
    if (!currentProof()) clear();
    if (!/^[1-9]\d{0,24}$/.test(customer) || !permitted()) { node.dataset.state = 'consent_or_account_missing'; return; }
    if (document.visibilityState === 'hidden') return;
    node.dataset.state = 'waiting_pixel';
    const ticket = revision;
    let visitor;
    for (let i=0; i<40; i++) {
      if (ticket !== revision || !permitted()) return;
      visitor = cookie('_cm_meta_id');
      if (/^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(visitor) && cookie('_cm_meta_account') === customer) break;
      visitor = '';
      await new Promise(resolve => setTimeout(resolve,250));
    }
    if (!visitor || ticket !== revision || !permitted()) { if (ticket === revision) node.dataset.state = 'pixel_not_ready'; return; }
    const controller = new AbortController();
    pending = controller;
    const timeout = setTimeout(() => controller.abort(),4000);
    try {
      node.dataset.state = 'proxy_pending';
      const nonce = crypto.randomUUID();
      const url = new URL('/apps/cm-meta-identity',window.location.origin);
      url.search = new URLSearchParams({cm_visitor:visitor,cm_nonce:nonce,cm_consent:'yes'}).toString();
      const response = await fetch(url.href,{credentials:'same-origin',cache:'no-store',signal:controller.signal});
      if (!response.ok) { node.dataset.state = 'proxy_http_'+response.status; return; }
      const p = await response.json();
      const now = Math.floor(Date.now()/1000);
      if (ticket !== revision || !permitted() || cookie('_cm_meta_id') !== visitor || cookie('_cm_meta_account') !== customer) return;
      if (p.identified !== true) { node.dataset.state = 'proxy_guest'; clear(); return; }
      if (p.visitor_id !== visitor || p.customer_id !== customer || p.nonce !== nonce ||
          !Number.isSafeInteger(p.expires) || p.expires <= now || p.expires > now+120 ||
          typeof p.proof !== 'string' || !p.proof || p.proof.length > 2048) { node.dataset.state = 'invalid_proof'; clear(); return; }
      const value = encodeURIComponent(JSON.stringify({visitor,customer,expires:p.expires,proof:p.proof}));
      document.cookie = cookieName+'='+value+'; Path=/; Max-Age='+Math.min(120,p.expires-now)+'; SameSite=Lax; Secure';
      node.dataset.state = currentProof() ? 'ready' : 'cookie_unavailable';
      void notifyPixel(ticket);
      refresh = setTimeout(() => { void start(); },90000);
    } catch { if (ticket === revision) node.dataset.state = 'proxy_network_error'; } finally {
      clearTimeout(timeout);
      if (pending === controller) pending = undefined;
    }
  };
  document.addEventListener('visitorConsentCollected',() => { void start(); });
  window.addEventListener('pagehide',() => stop(false));
  document.addEventListener('visibilitychange',() => { if (document.visibilityState === 'hidden') stop(false); else void start(); });
  window.addEventListener('pageshow',event => { if (event.persisted) void start(); });
  const ready = attempt => {
    if (window.Shopify?.customerPrivacy) { void start(); return; }
    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error => { if (!error) void start(); });
    } else if (attempt < 20) setTimeout(() => ready(attempt+1),150);
  };
  if (customer) ready(0); else clear();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cm-portal-design"] && !Shopify.designMode) return;
  try {
    (function(){
  var configNode=document.getElementById('cmp-ui-copy');
  if(!configNode)return;
  var text=JSON.parse(configNode.textContent);
  function el(tag,cls,content){var n=document.createElement(tag);if(cls)n.className=cls;if(content)n.textContent=content;return n;}
  function clone(id){var t=document.getElementById(id);return t?t.content.cloneNode(true):document.createDocumentFragment();}
  function link(label,url,cls){var a=el('a',cls,label);a.href=url;return a;}
  function boot(){
    var coming=document.querySelector('.cmr-coming-soon');if(coming&&!coming.dataset.cmpEnhanced){coming.dataset.cmpEnhanced='true';coming.prepend(clone('cmp-gift-template'));}
    var root=document.getElementById('cm-own-rewards');
    if(root&&!root.dataset.cmpEnhanced){
      root.dataset.cmpEnhanced='true';root.classList.add('cmp','cmp-rewards');
      var h1=root.querySelector('h1'),eyebrow=root.querySelector('.cmr-eyebrow'),intro=root.querySelector('.cmr-intro'),wallet=root.querySelector('.cmr-wallet'),headings=Array.from(root.querySelectorAll('h2'));
      var hero=el('div','cmp-hero'),copy=el('div','cmp-hero-copy'),art=el('div','cmp-hero-art');
      if(eyebrow){eyebrow.classList.add('cmp-eyebrow');copy.append(eyebrow);}if(h1)copy.append(h1);if(intro)copy.append(intro);
      var rate=el('span','cmp-rate',text.rate);copy.append(rate);art.append(clone('cmp-gift-template'));hero.append(copy,art);root.prepend(hero);root.prepend(clone('cmp-nav-template'));
      if(wallet){var contents=el('div','cmp-wallet-content');while(wallet.firstChild)contents.append(wallet.firstChild);var right=el('div','cmp-wallet-right'),seal=el('span','cmp-wallet-seal');seal.append(clone('cmp-gift-icon'));right.append(seal,el('p','',text.panel_note),link(text.shop+' →',text.shop_url));wallet.append(contents,right);
        var progress=el('progress','cmp-live-progress');progress.max=100;progress.value=0;progress.setAttribute('aria-label',text.next);var summary=root.querySelector('#cmr-summary'),balance=root.querySelector('#cmr-balance'),progressText=root.querySelector('#cmr-progress');
        if(summary&&balance&&progressText){summary.insertBefore(progress,progressText);function sync(){var n=Number(balance.textContent);var target=n<100?100:n<500?500:1500;progress.max=target;progress.value=Math.max(0,Math.min(Number.isFinite(n)?n:0,target));if(progress.hidden!==summary.hidden)progress.hidden=summary.hidden;}
          new MutationObserver(sync).observe(summary,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['hidden']});sync();}
      }
      root.querySelectorAll('.cmr-cards article').forEach(function(card,i){card.classList.add('cmp-reward','cmp-reward-'+(i+1));var top=el('div','cmp-reward-top'),icon=el('span','cmp-reward-icon');icon.append(clone('cmp-gift-icon'));top.append(el('span','cmp-reward-caption',text[['first','second','third'][i]]),icon);card.prepend(top);});
      if(headings[0]){var heading=el('div','cmp-heading');headings[0].before(heading);heading.append(headings[0],el('p','',text.rewards_intro));}
      var cards=root.querySelector('.cmr-cards');if(cards){var how=el('div','cmp-how'),steps=el('div','cmp-steps');how.append(el('h2','',text.how),steps);for(var i=1;i<=3;i++){var step=el('div','cmp-step'),body=el('div');body.append(el('h3','',text['step_'+i]),el('p','',text['step_'+i+'_body']));step.append(el('span','','0'+i),body);steps.append(step);}cards.after(how);}
      var codes=root.querySelector('#cmr-codes'),refresh=root.querySelector('#cmr-refresh'),faqNodes=Array.from(root.querySelectorAll('details'));
      var bottom=el('div','cmp-bottom'),codeBox=el('section','cmp-codes-box'),faq=el('section','cmp-faq'),small=el('span','cmp-small-icon');small.append(clone('cmp-gift-icon'));codeBox.append(small);
      if(headings[1])codeBox.append(headings[1]);if(codes)codeBox.append(codes);if(refresh)codeBox.append(refresh);if(headings[2])faq.append(headings[2]);faqNodes.forEach(function(d){faq.append(d);});bottom.append(codeBox,faq);root.append(bottom);
      var oldFooter=root.querySelector('.cmr-footer');if(oldFooter)oldFooter.remove();root.append(clone('cmp-footer-template'));
      if(codes){function addCopies(){codes.querySelectorAll('li').forEach(function(li){var code=li.querySelector('code');if(!code||li.querySelector('.cmp-copy'))return;var button=el('button','cmp-copy',text.copy_code);button.type='button';button.addEventListener('click',async function(){try{await navigator.clipboard.writeText(code.textContent);button.textContent=text.copied;setTimeout(function(){button.textContent=text.copy_code;},2000);}catch(e){button.textContent=text.copy_fail;}});li.append(button);});}new MutationObserver(addCopies).observe(codes,{childList:true});addCopies();}
    }
    var account=document.querySelector('[data-cmp-account][data-signed-in=true]');
    if(account&&!account.dataset.cmpLoaded){account.dataset.cmpLoaded='true';var note=account.querySelector('[data-cmp-balance-note]'),value=account.querySelector('[data-cmp-balance]');
      fetch(account.dataset.rewardsBase+'/account',{credentials:'same-origin',cache:'no-store'}).then(function(r){if(!r.ok||!(r.headers.get('content-type')||'').includes('application/json'))throw Error();return r.json();}).then(function(d){if(!Number.isFinite(d.balance))throw Error();value.textContent=d.balance.toLocaleString()+' '+text.points;value.hidden=false;note.textContent=text.view_balance;}).catch(function(){note.textContent=text.unavailable;});
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cm-priority-production"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const roots = [...document.querySelectorAll('cm-priority-production')];
    if (!roots.length || roots[0].dataset.initialised) return;
    const cartAPI = window.CartJS;
    const $ = window.jQuery;
    if (!cartAPI || !$) return;
    roots.forEach(root => { root.dataset.initialised = 'true'; });
    const variant = roots[0].dataset.variant;
    let ready = false;
    let busy = false;
    let failed = false;
    let operation = false;
    let desired = null;
    let originalFee = null;
    let pageNoteSaved = false;
    const service = item => String(item.variant_id || item.id) === variant;
    const snapshot = cart => ({
      fees: (cart.items || []).filter(service),
      eligible: (cart.items || []).some(item => !service(item) && item.requires_shipping)
    });
    const feeKey = state => state.fees.map(item => `${item.key}:${item.quantity}`).join('|');
    const isCartPage = () => !!document.querySelector('.cm-cart-page');
    const lockCheckout = () => {
      const locked = busy || failed;
      document.body.classList.toggle('cm-priority-lock', locked);
      [['cartDWcheckout', 'cartDWtearm'], ['cartCheckout', 'cartTearm']].forEach(([buttonId, termsId]) => {
        const button = document.getElementById(buttonId);
        const terms = document.getElementById(termsId);
        if (button) button.disabled = locked || !!(terms && !terms.checked);
      });
    };
    const render = cart => {
      const state = snapshot(cart);
      roots.forEach(root => {
        root.hidden = !state.eligible && !state.fees.length;
        const input = root.querySelector('input');
        input.checked = state.fees.length > 0;
        input.disabled = busy || failed || !state.eligible;
        root.setAttribute('aria-busy', String(busy));
        root.dataset.failed = String(failed);
        root.querySelector('.cm-priority-status').textContent = failed ? root.dataset.error : busy && operation ? root.dataset.updating : '';
        root.querySelector('button').hidden = !failed;
      });
      document.querySelectorAll('#cart-drawer [data-cm-variant-id]').forEach(row => row.classList.toggle('cm-priority-line', row.dataset.cmVariantId === variant));
      document.querySelectorAll('.cm-cart-page .cart__row').forEach(row => {
        const quantity = row.querySelector('input[name="updates[]"]');
        row.classList.toggle('cm-priority-line', !!quantity && quantity.id.startsWith(`updates_${variant}:`));
      });
      lockCheckout();
    };
    const error = () => { failed = true; };
    const normalise = cart => {
      if (failed) return false;
      const state = snapshot(cart);
      const updates = {};
      state.fees.forEach((item, index) => {
        const quantity = state.eligible && index === 0 ? 1 : 0;
        if (item.quantity !== quantity) updates[item.key] = quantity;
      });
      if (!Object.keys(updates).length) return false;
      operation = true;
      cartAPI.updateItemQuantitiesById(updates, { error });
      return true;
    };
    const settled = cart => {
      ready = true;
      busy = false;
      const state = snapshot(cart);
      if (originalFee === null) originalFee = feeKey(state);
      if (normalise(cart)) return;
      if (isCartPage() && !failed && originalFee !== feeKey(state)) {
        const note = document.querySelector('.cart-note__input');
        if (!pageNoteSaved && note && note.value !== cart.note) {
          pageNoteSaved = true;
          cartAPI.setNote(note.value, { error });
          return;
        }
        window.location.reload();
        return;
      }
      render(cart);
      if (operation && !failed && desired !== null) {
        roots.forEach(root => { root.querySelector('.cm-priority-status').textContent = state.fees.length ? root.dataset.added : root.dataset.removed; });
      }
      operation = false;
      desired = null;
    };
    $(document).on('cart.ready.cmPriority cart.requestComplete.cmPriority', (event, cart) => settled(cart || cartAPI.cart));
    $(document).on('cart.requestStarted.cmPriority', () => { busy = true; render(cartAPI.cart); });
    $(document).on('ajaxError.cmPriority', (event, xhr, settings) => {
      if (!operation) return;
      const path = new URL(settings.url, window.location.origin).pathname;
      if (/\/cart(?:\/(?:add|change|update))?\.js$/.test(path)) error();
    });
    roots.forEach(root => {
      root.querySelector('input').addEventListener('change', event => {
        if (!ready || busy || failed) { render(cartAPI.cart); return; }
        const state = snapshot(cartAPI.cart);
        desired = event.target.checked;
        if (!state.eligible) { render(cartAPI.cart); return; }
        operation = true;
        if (desired && !state.fees.length) {
          cartAPI.addItem(variant, 1, { _cm_service: 'priority_production' }, { error });
        } else if (!desired && state.fees.length) {
          const updates = Object.fromEntries(state.fees.map(item => [item.key, 0]));
          cartAPI.updateItemQuantitiesById(updates, { error });
        } else settled(cartAPI.cart);
      });
      root.querySelector('button').addEventListener('click', () => {
        if (busy) return;
        failed = false;
        operation = true;
        cartAPI.getCart({ error });
      });
    });
    document.addEventListener('change', event => {
      if (event.target.matches('#cartDWtearm, #cartTearm')) setTimeout(lockCheckout, 0);
    });
    const preventPendingCheckout = event => {
      if (!busy && !failed) return;
      if (event.type === 'submit') {
        if (!event.target.matches('form[action$="/cart"]')) return;
        if (event.submitter && event.submitter.name !== 'checkout') return;
      } else if (!event.target.closest('[name="checkout"], a[href*="/checkout"], .additional-checkout-buttons')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    };
    document.addEventListener('click', preventPendingCheckout, true);
    document.addEventListener('submit', preventPendingCheckout, true);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && ready && !busy) cartAPI.getCart({ error: () => { if (operation) error(); } });
    });
    if (cartAPI.cart && typeof cartAPI.cart.item_count === 'number') settled(cartAPI.cart);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cm-product-studio"] && !Shopify.designMode) return;
  try {
    (() => {
  function init(root) {
    if (root.dataset.cmPdpReady) return;
    root.dataset.cmPdpReady = 'true';
    root.classList.add('cm-pdp-ready');
    let frame;
    let lastState = '';
    let lastSummary;
    const visible = element => Boolean(element.getClientRects().length) && getComputedStyle(element).visibility !== 'hidden';
    const labelFor = control => control.closest('.ymq-options-box')?.dataset.label || control.labels?.[0]?.textContent.trim() || control.getAttribute('aria-label') || '';
    const fontPickers = new WeakMap();
    function refreshFontPicker(form) {
      const config = form.querySelector('[data-cm-font-config]');
      if (!config) return;
      const box = Array.from(form.querySelectorAll('#ymq-box .ymq-options-box')).find(item => item.dataset.label?.trim().toLowerCase() === 'font');
      const select = box?.querySelector('select');
      if (!select) return;
      const prior = fontPickers.get(select);
      if (prior) { prior.sync?.(); return; }
      const options = Array.from(select.options).filter(option => option.value);
      if (options.length !== 4) return;
      const sets = {
        kids: {names:['Reuben','Oakley','Millie','Charlotte'], views:['110 145 330 77','575 145 330 77','110 273 330 77','575 273 330 77']},
        words: {names:['Reuben','Olivia','Millie','Noah'], views:['110 180 355 110','550 180 355 110','110 340 355 110','550 340 355 110']}
      };
      const set = sets[config.dataset.set];
      if (!set) return;
      const state = {};
      fontPickers.set(select,state);
      const asset = new Image();
      asset.onload = () => {
        if (!select.isConnected || box.querySelector('.cm-font-grid')) return;
        const grid = document.createElement('div');
        grid.className = 'cm-font-grid';
        grid.setAttribute('role','radiogroup');
        grid.setAttribute('aria-label',box.dataset.label);
        grid.setAttribute('aria-required','true');
        const error = document.createElement('p');
        error.className = 'cm-font-error';
        error.id = select.id + '-visual-error';
        error.setAttribute('role','alert');
        error.textContent = config.dataset.error;
        error.hidden = true;
        grid.setAttribute('aria-describedby',error.id);
        const cards = options.map((option,index) => {
          const card = document.createElement('button');
          card.type = 'button';
          card.className = 'cm-font-card';
          card.setAttribute('role','radio');
          card.dataset.value = option.value;
          const caption = config.dataset.example.replace('__name__',set.names[index]);
          card.setAttribute('aria-label',config.dataset.prefix + ' ' + (index + 1) + ' — ' + caption);
          card.setAttribute('aria-checked','false');
          card.tabIndex = index === 0 ? 0 : -1;
          const number = document.createElement('span');
          number.className = 'cm-font-number';
          number.textContent = config.dataset.prefix + ' ' + (index + 1);
          const tick = document.createElement('span');
          tick.className = 'cm-font-tick';
          tick.setAttribute('aria-hidden','true');
          tick.textContent = '✓';
          const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
          svg.classList.add('cm-font-sample');
          svg.setAttribute('viewBox',set.views[index]);
          svg.setAttribute('aria-hidden','true');
          svg.setAttribute('focusable','false');
          const image = document.createElementNS('http://www.w3.org/2000/svg','image');
          image.setAttribute('href',config.dataset.image);
          image.setAttribute('width','1000');
          image.setAttribute('height','1000');
          svg.append(image);
          const name = document.createElement('span');
          name.className = 'cm-font-caption';
          name.textContent = caption;
          card.append(number,tick,svg,name);
          card.addEventListener('click',() => {
            if (select.value !== option.value) {
              select.value = option.value;
              select.setCustomValidity('');
              select.dispatchEvent(new Event('input',{bubbles:true}));
              select.dispatchEvent(new Event('change',{bubbles:true}));
            }
            state.sync();
            schedule();
          });
          card.addEventListener('keydown',event => {
            const shifts = {ArrowRight:1,ArrowDown:1,ArrowLeft:-1,ArrowUp:-1};
            let next;
            if (event.key in shifts) next = (index + shifts[event.key] + cards.length) % cards.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = cards.length - 1;
            else return;
            event.preventDefault();
            cards[next].click();
            cards[next].focus();
          });
          return card;
        });
        grid.append(...cards);
        select.after(grid,error);
        select.classList.add('cm-font-native');
        select.tabIndex = -1;
        select.setAttribute('aria-hidden','true');
        box.classList.add('cm-font-options');
        const help = box.querySelector('.ymq_help_box');
        if (help) help.textContent = config.dataset.help;
        state.sync = () => {
          const chosen = cards.findIndex(card => card.dataset.value === select.value);
          cards.forEach((card,index) => {
            const checked = index === chosen;
            const nextChecked = String(checked);
            if (card.getAttribute('aria-checked') !== nextChecked) card.setAttribute('aria-checked',nextChecked);
            const tabIndex = index === (chosen < 0 ? 0 : chosen) ? 0 : -1;
            if (card.tabIndex !== tabIndex) card.tabIndex = tabIndex;
          });
          if (chosen >= 0) {
            error.hidden = true;
            grid.removeAttribute('aria-invalid');
          } else if (select.classList.contains('ymq_error_border')) {
            error.hidden = false;
            grid.setAttribute('aria-invalid','true');
          }
        };
        select.addEventListener('change',state.sync);
        select.addEventListener('focus',() => {
          state.sync();
          grid.querySelector('[role="radio"][tabindex="0"]').focus();
        });
        state.sync();
        schedule();
      };
      asset.src = config.dataset.image;
    }
    function refresh() {
      frame = null;
      if (!root.isConnected) { observer.disconnect(); return; }
      const form = root.querySelector('form.productForm');
      if (!form) return;
      refreshFontPicker(form);
      const summary = form.querySelector('[data-cm-summary]');
      const choices = summary?.querySelector('[data-cm-choices]');
      const personalisation = summary?.querySelector('[data-cm-personalisation]');
      const note = summary?.querySelector('[data-cm-summary-note]');
      const dock = root.querySelector('[data-cm-dock]');
      const price = root.querySelector('[id^="ProductPrice-"]');
      const purchase = form.querySelector('[name="add"]');
      const app = form.querySelector('#ymq-box');
      const controls = Array.from((app || form).querySelectorAll(app ? 'select,input:not([type="hidden"]),textarea' : '.single-option-selector,input[name^="properties["],textarea[name^="properties["]')).filter(visible);
      root.querySelectorAll('.prTabs .tablink').forEach(link => {
        const pane = root.querySelector(link.getAttribute('href'));
        const title = pane?.classList.contains('reviewtab') ? summary?.dataset.reviewsTitle : pane?.classList.contains('product-description') ? summary?.dataset.detailsTitle : null;
        const textNode = Array.from(link.childNodes).find(node => node.nodeType === 3 && node.textContent.trim());
        if (title && textNode && textNode.textContent.trim() !== title) textNode.textContent = title + ' ';
      });
      const nativeName = form.querySelector('[data-cm-name-input]');
      if (nativeName && !controls.includes(nativeName)) controls.push(nativeName);
      const hasTextField = controls.some(control => control.tagName === 'TEXTAREA' || ['text','email','tel'].includes(control.type));
      const selected = [];
      const text = [];
      let missing = false;
      for (const control of controls) {
        if (['submit','button','file'].includes(control.type) || control.disabled) continue;
        const label = labelFor(control);
        const box = control.closest('.ymq-options-box');
        if (box && summary && (control.tagName === 'TEXTAREA' || control.type === 'text') && !box.querySelector('.cm-pdp-field-kicker')) {
          const heading = document.createElement('p');
          heading.className = 'cm-pdp-field-kicker';
          heading.textContent = summary.dataset.fieldLabel;
          box.prepend(heading);
        }
        if (label && !control.getAttribute('aria-label') && !control.labels?.length) control.setAttribute('aria-label',label);
        if (control.tagName === 'SELECT') {
          for (const option of control.options) if (!option.textContent.trim() && option.value) option.textContent = option.value;
        }
        const value = String(control.value || '').trim();
        const required = control.required || control.closest('[data-validate="required"]');
        if (required && !value) missing = true;
        if (!value || (['radio','checkbox'].includes(control.type) && !control.checked)) continue;
        if (control.tagName === 'TEXTAREA' || ['text','email','tel'].includes(control.type)) text.push(value);
        else if (label) selected.push([label,value]);
      }
      const state = JSON.stringify({selected,text,missing,hasTextField});
      if (summary && (state !== lastState || summary !== lastSummary)) {
        lastState = state;
        lastSummary = summary;
        personalisation.textContent = text.join('\n');
        choices.replaceChildren(...selected.map(([label,value]) => {
          const item = document.createElement('div');
          const term = document.createElement('dt');
          const description = document.createElement('dd');
          term.textContent = label;
          description.textContent = value;
          item.append(term,description);
          return item;
        }));
        summary.hidden = !controls.length || (hasTextField && !text.length);
        note.textContent = missing ? summary.dataset.missing : text.length ? summary.dataset.check : summary.dataset.empty;
      }
      if (dock && price) {
        const priceText = price.textContent.trim();
        const dockPrice = dock.querySelector('[data-cm-dock-price]');
        if (dockPrice.textContent !== priceText) dockPrice.textContent = priceText;
      }
      if (dock && purchase) {
        const rect = purchase.getBoundingClientRect();
        const belowIntro = window.scrollY > root.getBoundingClientRect().top + window.scrollY + 80;
        const formRect = form.getBoundingClientRect();
        const mobileFormVisible = matchMedia('(max-width: 767px)').matches && formRect.top < window.innerHeight && formRect.bottom > 90;
        dock.hidden = mobileFormVisible || !belowIntro || (rect.top >= 80 && rect.bottom < window.innerHeight - 90) || !visible(purchase) || purchase.disabled;
      }
    }
    const schedule = () => { if (!frame) frame = requestAnimationFrame(refresh); };
    const observer = new MutationObserver(mutations => {
      if (mutations.some(m => !m.target.closest?.('[data-cm-summary],[data-cm-dock]'))) schedule();
    });
    observer.observe(root,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class','style','disabled','value']});
    const clearValidation = event => { event.target.setCustomValidity?.(''); schedule(); };
    root.addEventListener('input',clearValidation);
    root.addEventListener('change',clearValidation);
    const guardPersonalisation = event => {
      if (event.type === 'click' && !event.target.closest('[name="add"]')) return;
      const form = event.target.closest('form.productForm');
      if (!form) return;
      const invalid = Array.from(form.querySelectorAll('#ymq-box select,#ymq-box input:not([type="hidden"]),#ymq-box textarea')).find(control => visible(control) && !control.disabled && !['radio','checkbox','file'].includes(control.type) && control.closest('[data-validate="required"]') && !String(control.value || '').trim());
      if (!invalid) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (invalid.classList.contains('cm-font-native')) {
        const box = invalid.closest('.ymq-options-box');
        const grid = box.querySelector('.cm-font-grid');
        const error = box.querySelector('.cm-font-error');
        grid.setAttribute('aria-invalid','true');
        error.hidden = false;
        grid.querySelector('[role="radio"]').focus();
        schedule();
        return;
      }
      invalid.setCustomValidity(form.querySelector('[data-cm-summary]')?.dataset.required || invalid.validationMessage);
      invalid.reportValidity();
      schedule();
    };
    root.addEventListener('submit',guardPersonalisation,true);
    root.addEventListener('click',guardPersonalisation,true);
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    root.addEventListener('click',event => {
      const open = event.target.closest('[data-cm-guide-open]');
      if (open) {
        event.preventDefault();
        const dialog = root.querySelector('dialog.cm-pdp-guide');
        if (dialog && !dialog.open) dialog.showModal();
      }
      const close = event.target.closest('[data-cm-guide-close]');
      if (close) close.closest('dialog').close();
      if (event.target.matches('dialog.cm-pdp-guide')) {
        const dialog = event.target;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
      if (event.target.closest('[data-cm-return]')) root.querySelector('form.productForm')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    });
    refresh();
  }
  const start = () => document.querySelectorAll('.cm-pdp').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start); else start();
  document.addEventListener('shopify:section:load',start);
})();
  } catch(e) { console.error(e); }
})();

})();
